var map = {
	"./Dust&Magnet/Dust&Magnet.json": 79111,
	"./ParallelCoordinate/ParallelCoordinate.json": 89213,
	"./SPLOM/SPLOM copy.json": 15668,
	"./SPLOM/SPLOM.json": 12914,
	"./home/home.json": 6714,
	"./pan&zoom/pan.json": 55784,
	"./teaser-Matrix/Matrix.json": 65300,
	"./user.json": 59047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60973;